import React from 'react';

import { STATUS_ALL, STATUS_APPROVED_BY_ME, STATUS_PENDING, STATUS_REJECTED_BY_ME, statusFilterLabel, typeChipLabel } from './queueTypes';

import SelectInput from 'CommonComponents/SelectInput';

const STATUSES = [STATUS_PENDING, STATUS_APPROVED_BY_ME, STATUS_REJECTED_BY_ME, STATUS_ALL];

/**
 * The register's two filters: which kinds of approval, and whose decision.
 *
 * DROPDOWNS RATHER THAN THE CHIP ROW MY REQUESTS USES. Chips carry a badge each
 * and only work while the axis is short; two axes multiplied out give a strip
 * the user has to read rather than aim at.
 *
 * THE TYPE LIST IS WHATEVER THE SERVER COUNTED. `counts_by_type` omits a type
 * holding nothing, so there is no option that leads to an empty table — and
 * because the server never narrows that block by the selected type, choosing one
 * does not remove its neighbours from the list.
 *
 * An "All types" option is always offered, even at one type: it is what the user
 * returns to, and hiding it would leave a single-type register with a filter
 * that cannot be cleared.
 */
export default function QueueFilters({ countsByType = {}, type, onTypeChange, status, onStatusChange }) {
    const types = Object.keys(countsByType);

    return (
        <div className="tw-mb-4 tw-flex tw-flex-wrap tw-items-end tw-gap-4">
            {/* `id` as well as `name`: SelectInput's htmlFor is actually set to
                `props.name`, not `props.id` (see SelectInput.js), so the label
                only associates here because the two are set to the same
                string. Keep them equal — dropping `name` on a future edit
                would detach the label silently, and an aria-label patched over
                the gap would have a screen reader announce something other
                than the words on screen. */}
            <SelectInput
                id="home-approvals-type"
                name="home-approvals-type"
                label="Type"
                value={type ?? ''}
                onChange={(event) => onTypeChange(event.target.value || null)}
            >
                <option value="">{$t('All types')}</option>
                {types.map((value) => (
                    <option key={value} value={value}>
                        {typeChipLabel(value)}
                    </option>
                ))}
            </SelectInput>

            <SelectInput
                id="home-approvals-status"
                name="home-approvals-status"
                label="Status"
                value={status}
                onChange={(event) => onStatusChange(event.target.value)}
            >
                {STATUSES.map((value) => (
                    <option key={value} value={value}>
                        {statusFilterLabel(value)}
                    </option>
                ))}
            </SelectInput>
        </div>
    );
}
